import { render, staticRenderFns } from "./ModifyPassword.vue?vue&type=template&id=11932bd8"
import script from "./ModifyPassword.vue?vue&type=script&lang=js"
export * from "./ModifyPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports